const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      VERIFY: '/auth/verify',
    },
    ORDERS: {
      VALIDATE: '/inbound/orders/validate',
      RECEIVE: '/inbound/orders/receive',
      LIST: '/inbound/orders',
    },
    PUTAWAY: {
      ITEMS: '/inbound/putaway/items',
      CREATE: '/inbound/putaway',
    }
  }
};

export default config; 